import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_DOMAIN, // optional, cleaner usage
  withCredentials: true, // ensures cookies are sent
  headers: {
    "Content-Type": "application/json",
  },
});

// Fetch wrapper with credentials included by default
export const fetchInstance = async (
  input: RequestInfo,
  init: RequestInit = {}
) => {
  return await fetch(input, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(init.headers || {}),
    },
    ...init,
  });
};
